export default [
  {
    path: '/contacts',
    name: 'contacts',
    component: () => import('@/views/contacts/Contacts.vue'),
    meta: {
      protected: true,
      pageTitle: 'Contacts',
      breadcrumb: [
        {
          text: 'Contacts',
          active: true,
        },
      ],
    },
  },
]
